<template>
    <div class="page-loader">
        <div class="loader"></div>
    </div>
</template>
<script setup lang="ts"></script>
<style scoped lang="css">
    .page-loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.85);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }

    .loader {
        width: 200px;
        aspect-ratio: 1;
        border-radius: 50%;
        border: 2px solid;
        box-sizing: border-box;
        position: relative;
        transform-origin: left;
        animation: earth 5s infinite linear;
    }

        .loader::before,
        .loader::after {
            content: "";
            position: absolute;
            inset: 0 0 auto;
            margin: auto;
            width: 50%;
            aspect-ratio: 1;
            border-radius: 50%;
            border: 2px solid;
            box-sizing: content-box;
            transform-origin: 50% calc(100% - 4px);
        }

        .loader::after {
            inset: auto 0 calc(100% + 2px);
            animation: sun 5s infinite linear;
            animation-duration: 2.5s;
            animation-direction: reverse;
            transform-origin: 50% calc(200% - 2px);
        }

        .loader::before {
            animation: moon 5s infinite linear;
        }

    .loader {
        color: #845EC2;
    }

        .loader::before {
            color: green;
        }

        .loader::after {
            color: #F3D400;
        }

    @keyframes sun {
        0% {
            color: #845EC2;
        }

        12.5% {
            color: #A178DF;
        }

        25% {
            color: #BE93FD;
        }

        37.5% {
            color: #DCB0FF;
        }

        50% {
            color: #FACCFF;
        }

        62.5% {
            color: #DCB0FF;
        }

        75% {
            color: #BE93FD;
        }

        87.5% {
            color: #A178DF;
        }

        100% {
            transform: rotate(1turn);
            color: #845EC2;
        }
    }

    @keyframes moon {
        0% {
            color: #94B0B2;
        }

        12.5% {
            color: #708B8D;
        }

        25% {
            color: #4D686A;
        }

        37.5% {
            color: #2D4648;
        }

        50% {
            color: #0E2729;
        }

        62.5% {
            color: #2D4648;
        }

        75% {
            color: #4D686A;
        }

        87.5% {
            color: #708B8D;
        }

        100% {
            transform: rotate(1turn);
            color: #94B0B2;
        }
    }

    @keyframes earth {
        0% {
            color: #D43725;
        }

        12.5% {
            color: #F5563D;
        }

        25% {
            color: #FF7356;
        }

        37.5% {
            color: #FF9070;
        }

        50% {
            color: #FFAE8B;
        }

        62.5% {
            color: #FF9070;
        }

        75% {
            color: #FF7356;
        }

        87.5% {
            color: #F5563D;
        }

        100.00% {
            color: #D43725;
            transform: rotate(1turn)
        }
    }
</style>